var image_upload_default = {
  "container": "ivE80",
  "disabled": "fUJ7E",
  "imageInput": "_2PQ-L",
  "overlay": "UknvO",
  "text": "Pd-Iw",
  "shown": "qANji",
  "hide": "EoO8Y",
  "spinner": "qfv2H",
  "spin": "e39Au"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
